import {
  BriefcaseIcon,
  DocumentTextIcon,
  LightBulbIcon,
  BuildingOfficeIcon,
  HomeIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  GiftIcon
} from '@heroicons/react/24/outline';

// Income types with icons and descriptions
export const INCOME_TYPES = [
  {
    id: 'SALARY',
    title: 'Salary/W2',
    description: 'Regular employment income',
    icon: BriefcaseIcon,
    disabled: false
  },
  {
    id: 'CONTRACT',
    title: 'Contract/1099',
    description: 'Fixed-term contract work',
    icon: DocumentTextIcon,
    disabled: false
  },
  {
    id: 'CONSULTING',
    title: 'Consulting',
    description: 'Professional consulting services',
    icon: LightBulbIcon,
    disabled: true,
    comingSoon: true
  },
  {
    id: 'BUSINESS',
    title: 'Business',
    description: 'Business or self-employment income',
    icon: BuildingOfficeIcon,
    disabled: true,
    comingSoon: true
  },
  {
    id: 'RENTAL',
    title: 'Rental',
    description: 'Income from property rentals',
    icon: HomeIcon,
    disabled: true,
    comingSoon: true
  },
  {
    id: 'INVESTMENT',
    title: 'Investments',
    description: 'Investment returns and dividends',
    icon: ChartBarIcon,
    disabled: true,
    comingSoon: true
  },
  {
    id: 'SIDE_HUSTLE',
    title: 'Side Hustle',
    description: 'Additional income streams',
    icon: CurrencyDollarIcon,
    disabled: true,
    comingSoon: true
  },
  {
    id: 'GIFT',
    title: 'Gift',
    description: 'Monetary gifts or inheritance',
    icon: GiftIcon,
    disabled: true,
    comingSoon: true
  }
];

// Payment frequencies
export const PAYMENT_FREQUENCIES = [
  { id: 'WEEKLY', label: 'Weekly', multiplier: 52 },
  { id: 'BIWEEKLY', label: 'Bi-Weekly', multiplier: 26 },
  { id: 'SEMIMONTHLY', label: 'Semi-Monthly', multiplier: 24 },
  { id: 'MONTHLY', label: 'Monthly', multiplier: 12 },
  { id: 'QUARTERLY', label: 'Quarterly', multiplier: 4 },
  { id: 'ANNUALLY', label: 'Annually', multiplier: 1 }
];

// US States for tax calculations
export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
  { code: 'DC', name: 'District of Columbia' }
]; 